module.exports = __webpack_public_path__ + "static/img/clearing_white_03.6801a094.svg";